<template>
  <div id='educationList'>
    <Empty v-if="detail.totalCount === 0" />
    <van-list
      v-else
      v-model="detail.loading"
      :finished="detail.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="box"
        v-for="item in detail.list"
        :key="item.id"
        @click="$router.push({name:'EducationView',params:{id:item.id},query:{title:item.title}})"
      >
        <div class="left">
          <van-image class="img" :src="item.defaultImage || require('@/assets/images/study/img_default_01.png')"></van-image>
        </div>
        <div class="right">
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  data () {
    return {
      detail: {
        finished: false,
        loading: false,
        pageSize: 6,
        pageNo: 1,
        list: [],
        totalPage: ''
      }
    };
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    onLoad () {
      const { detail } = this;
      const { pageSize, pageNo } = detail;
      this.$http.get('courseTeach/theme/list', {
        params: {
          pageNo,
          pageSize
        }
      }).then(({ data }) => {
        const { nextPage, isHasNext, result, totalPage } = data || {};
        detail.finished = !isHasNext;
        detail.pageNo = nextPage;
        detail.totalPage = totalPage;
        detail.list.push(...result);
        detail.loading = false;

        this.detail = detail;
      });
    }
  }
};
</script>

<style scoped lang="less">
  #educationList{
    padding:0 28px;
    .box{
      display: flex;
      width: 100%;
      &:not(&:last-child){
        margin-bottom: 40px;
      }
      .left{
        margin-right: 28px;
        .img{
          width: 216px;
          height: 144px;
          border-radius: 8px;
        }
      }
      .right{
        width: 100%;
        .title{
          font-size: 26px;
          font-weight: bold;
          color: #333444;
        }
      }
    }
  }
</style>
